import { render, staticRenderFns } from "./FollowupsSummaryCards.vue?vue&type=template&id=7e61236c&scoped=true"
import script from "./FollowupsSummaryCards.vue?vue&type=script&lang=js"
export * from "./FollowupsSummaryCards.vue?vue&type=script&lang=js"
import style0 from "./FollowupsSummaryCards.vue?vue&type=style&index=0&id=7e61236c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e61236c",
  null
  
)

export default component.exports